import API from "api/client";
import { envConfig } from "config";

const { marketingAPI } = envConfig;

/**
 * @typedef { import("types/insights").InsightItemData } InsightItemData
 */
/**
 * @typedef { import("types/marketing").WeeklyEmailItemData } WeeklyEmailItemData
 */

/**
 * Returns a list of "InsightItemData".
 * An insight represents a blog post from our public marketing site.
 *
 * @param {object} params
 * @param {number} [params.page]
 * @param {number} [params.size]
 * @returns {Promise<InsightItemData[]>}
 */
const getInsights = ({ page = 1, size = 4 } = {}) =>
  API.get(`${marketingAPI}insights`, { params: { page, size } }).then((res) => res.data);

/**
 * Returns a list of "Weekly Emails"
 *
 * @param {number} page - which page
 * @param {number} size - how many per page
 * @returns {Promise<WeeklyEmailItemData[]>}
 */
const getWeeklyEmails = (page = 1, size = 5) => {
  return API.get(`${marketingAPI}weekly-emails`, { params: { page, size } }).then((res) => res.data);
};

export default {
  getInsights,
  getWeeklyEmails,
};
